import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";
import StraightLine from "./StraightLine";

/**
 * FastSTO (Estocástico Rápido, FML.FastSTO) — painel próprio, 2 linhas
 * (%K e %D) + linhas de referência 80/20 tracejadas (aparência, padrão odin;
 * no legado eram params UpperLine/LowerLine do cálculo). yAccessor(d)
 * retorna { k, d }.
 */
class FastSTOSeries extends Component {
  constructor(props) {
    super(props);
    this.kAccessor = this.kAccessor.bind(this);
    this.dAccessor = this.dAccessor.bind(this);
  }
  kAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.k;
  }
  dAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.d;
  }
  render() {
    const {
      strokeK,
      strokeD,
      showZones,
      overBought,
      overSold,
      className,
      onDoubleClick,
      onContextMenu,
    } = this.props;

    const overBoughtValue =
      overBought?.value !== undefined ? overBought.value : 80;
    const overSoldValue = overSold?.value !== undefined ? overSold.value : 20;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.kAccessor}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeK}
          fill="none"
        />
        <LineSeries
          yAccessor={this.dAccessor}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeD}
          fill="none"
        />
        {showZones && (
          <>
            <StraightLine
              stroke={
                overBought?.stroke || {
                  color: "#B8C2CC",
                  dash: "Dash",
                  width: 1,
                  opacity: 1,
                }
              }
              yValue={overBoughtValue}
            />
            <StraightLine
              stroke={
                overSold?.stroke || {
                  color: "#B8C2CC",
                  dash: "Dash",
                  width: 1,
                  opacity: 1,
                }
              }
              yValue={overSoldValue}
            />
          </>
        )}
      </g>
    );
  }
}

FastSTOSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeK: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeD: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  showZones: PropTypes.bool,
  overBought: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({ value: PropTypes.number, stroke: PropTypes.object }),
  ]),
  overSold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({ value: PropTypes.number, stroke: PropTypes.object }),
  ]),
  className: PropTypes.string,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

FastSTOSeries.defaultProps = {
  strokeK: { color: "#FFFF00" },
  strokeD: { color: "#FF0000" },
  showZones: true,
  className: "react-stockcharts-faststo-series",
};

export default FastSTOSeries;
